import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Form, Input, Radio, Space } from 'antd';
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { AddressStatusEnum } from "../../api/Representation";
import { isStringNotBlank } from "../../../../swzutils/TypeUtils";
const DeliveryAddressTableFilter = ({ defaultContactPhone = null, defaultAddressStreet = null, defaultAddressSuburb = null, defaultAddressStatus = null, onApplyFilter, onClearFilter }) => {
    const [form] = Form.useForm();
    const toFilterValue = (val) => {
        return isStringNotBlank(val) ? [val] : null;
    };
    const applyFilterClicked = (formValues) => {
        onApplyFilter(toFilterValue(formValues.contactPhone), toFilterValue(formValues.addressStreet), toFilterValue(formValues.addressSuburb), toFilterValue(formValues.addressStatus));
    };
    const clearFilterClicked = () => {
        form.setFieldsValue({
            contactPhone: null,
            addressStreet: null,
            addressSuburb: null,
            addressStatus: null,
        });
        onClearFilter();
    };
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsxs(Form, { layout: "vertical", form: form, onFinish: applyFilterClicked, initialValues: {
                    contactPhone: defaultContactPhone,
                    addressStreet: defaultAddressStreet,
                    addressSuburb: defaultAddressSuburb,
                    addressStatus: defaultAddressStatus,
                }, children: [_jsx(Form.Item, { name: "contactPhone", style: { marginBottom: 5 }, children: _jsx(Input, { placeholder: "Contact Phone", style: { width: "100%" } }) }), _jsx(Form.Item, { name: "addressStreet", style: { marginBottom: 5 }, children: _jsx(Input, { placeholder: "Street Address", style: { width: "100%" } }) }), _jsx(Form.Item, { name: "addressSuburb", style: { marginBottom: 5 }, children: _jsx(Input, { placeholder: "Suburb", style: { width: "100%" } }) }), _jsx(Form.Item, { name: "addressStatus", style: { marginBottom: 10 }, children: _jsx(Radio.Group, { options: [
                                { label: 'Validated', value: AddressStatusEnum.VALIDATED },
                                { label: 'Invalid', value: AddressStatusEnum.INVALID }
                            ] }) })] }), _jsxs(Space, { children: [_jsxs(Button, { type: "primary", onClick: form.submit, children: [_jsx(SearchOutlined, {}), " Apply"] }), _jsxs(Button, { type: "default", onClick: clearFilterClicked, children: [_jsx(CloseOutlined, {}), " Clear"] })] })] }));
};
const deliveryAddressSuburbLikeRequestKey = 'deliveryAddressSuburbLike';
const deliveryAddressStreetLikeRequestKey = 'deliveryAddressStreetLike';
const deliveryContactPhoneLikeRequestKey = 'deliveryContactPhoneLike';
const deliveryAddressStatusRequestKey = 'deliveryAddressStatus';
const DeliveryAddressTableFilterBuilder = (col, filters, openFilterKey, setOpenFilterKey, applyFilterKeys, clearFilterKeys) => {
    const filter = col.filter;
    return {
        ...col,
        key: `unused-${filter.requestKey}`,
        filterMultiple: false,
        filteredValue: filters[deliveryContactPhoneLikeRequestKey] || filters[deliveryAddressStreetLikeRequestKey] || filters[deliveryAddressSuburbLikeRequestKey] || filters[deliveryAddressStatusRequestKey],
        filterDropdownProps: {
            open: openFilterKey === filter.requestKey,
            onOpenChange: (visible) => {
                setOpenFilterKey(visible ? filter.requestKey : undefined);
            }
        },
        filterDropdown: (_jsx(DeliveryAddressTableFilter, { defaultContactPhone: filters[deliveryContactPhoneLikeRequestKey], defaultAddressStreet: filters[deliveryAddressStreetLikeRequestKey], defaultAddressSuburb: filters[deliveryAddressSuburbLikeRequestKey], defaultAddressStatus: filters[deliveryAddressStatusRequestKey], onApplyFilter: (contactPhone, addressStreet, addressSuburb, addressStatus) => {
                applyFilterKeys({
                    [deliveryContactPhoneLikeRequestKey]: contactPhone,
                    [deliveryAddressStreetLikeRequestKey]: addressStreet,
                    [deliveryAddressSuburbLikeRequestKey]: addressSuburb,
                    [deliveryAddressStatusRequestKey]: addressStatus
                });
            }, onClearFilter: () => clearFilterKeys([deliveryContactPhoneLikeRequestKey, deliveryAddressStreetLikeRequestKey, deliveryAddressSuburbLikeRequestKey, deliveryAddressStatusRequestKey]) }))
    };
};
export default DeliveryAddressTableFilterBuilder;
